<mat-card appearance="outlined" class="marginContent">
    <div class="mat-elevation-z0" style="word-break: inherit; overflow: auto; width: 100%;" fxLayout="column"
        fxLayoutAlign="start stretch">

        <div fxLayout="row" fxLayoutAlign="space-between center" style="padding:0px 10px">
            <span>
                {{ dialogData.nomeTabela + ' - ' + dialogData.idTabela }}
            </span>
            <button mat-raised-button color="action" style="align-self: end;" (click)="buscarDados()">
                <mat-icon>refresh</mat-icon>Recarregar
            </button>
        </div>
        <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0" matSortActive="displayWith"
            matSortDirection="asc" multiTemplateDataRows>

            <ng-container *ngFor="let column of columns;" [matColumnDef]="column.columnDef">

                <mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.header }}</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <idba-mat-table-cell [column]="column" [row]="row"></idba-mat-table-cell>
                </mat-cell>

            </ng-container>


            <ng-container matColumnDef="expand">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row" (click)="row.expanded = !row.expanded">
                    <mat-icon *ngIf="row.expanded" matTooltip="Esconder Detalhes">visibility_off</mat-icon>
                    <mat-icon *ngIf="!row.expanded" matTooltip="Visualizar Detalhes">visibility</mat-icon>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div *ngIf="element.expanded" [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'"
                        fxLayout="column" style="padding:16px;">
                        <span *ngFor="let linha of element.log.split('|')">
                            {{linha}}
                        </span>
                    </div>
                </td>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row;     columns: displayedColumns;   let entry"
                [ngClass]="{ 'detail-row': entry.expanded }"></mat-row>
            <mat-row *matRowDef="let element; columns: ['expandedDetail']; let entry"
                [ngClass]="{ 'motivo-row': !entry.expanded }"></mat-row>

        </mat-table>
    </div>
</mat-card>
